import { call, takeLatest } from "redux-saga/effects";
import * as storeApis from "../apis/storeApis"
import { CREATE_STORE, EDIT_STORE, EXPORT_STORES, LIST_STORE, UPLOAD_STORE_IMAGE, VIEW_STORE } from "../actions/types";


export function* createStoreWorker(action) {
    try {
        const res = yield call(storeApis.createStoreApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* editStoreWorker(action) {
    try {
        const res = yield call(storeApis.editStoreApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* listStoreWorker(action) {
    try {
        const res = yield call(storeApis.listStoreApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* viewStoreWorker(action) {
    try {
        const res = yield call(storeApis.viewStoreApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* uploadStoreImageWorker(action) {
    try {
        const file = new FormData();
        file.append("file", action.file);
        const res = yield call(storeApis.uploadStoreImageApi, file);

        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* exportStoresWorker(action) {
    try {
        const res = yield call(storeApis.exportStoresApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


/**Watcher Func */
export function* createStoreWatcher() {
    yield takeLatest(CREATE_STORE, createStoreWorker);
}
export function* editStoreWatcher() {
    yield takeLatest(EDIT_STORE, editStoreWorker);
}
export function* listStoreWatcher() {
    yield takeLatest(LIST_STORE, listStoreWorker);
}
export function* viewStoreWatcher() {
    yield takeLatest(VIEW_STORE, viewStoreWorker);
}
export function* uploadStoreImageWatcher() {
    yield takeLatest(UPLOAD_STORE_IMAGE, uploadStoreImageWorker);
}
export function* exportStoresWatcher() {
    yield takeLatest(EXPORT_STORES, exportStoresWorker);
}